import type { TridentCampaignDetails } from 'types/trident-campaigns';
import React, { Component } from 'react';
import i18n from 'i18n-js';
import CDatePicker from 'components/custom/CDatePicker';
import _ from 'lodash';

import FormInputWithError from 'components/form/FormInputWithError';
import { Form, Grid, Checkbox, Icon } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import CDropdown from 'components/custom/CDropdown';
import SegPWidget from './SegPWidget';
import { targetUserTypes } from 'omega-rtc/data/trident-types';


type Props = {
  model: TridentCampaignDetails,
  currentNode: string,
  subActionIndex: number,
  onModelChange: (_?: Object) => void,
  handleInputChange: Function,
  handleControlBlur: Function,
};

const MEX_SEGMENT_SUB_ACTIONS = ['updateMexGroupMembership', 'updatePaxDigibankSegmentMembership'];
const GXS_NAMESPACE = 'gxs';

@formComponent()
export default class ActionupdateSegmentMembershipForm extends Component {
  props: Props;

  handleToggleCreate = () => {
    if (this.props.onModelChange) {
      const newModel = _.cloneDeep(this.props.model);
      const isCreateNewSegment = !_.get(
        newModel.nodes[this.props.currentNode],
        `data[${this.props.subActionIndex}].meta.updateSegMembershipPayload.isCreateNewSegment`,
      );
      // _.set(newModel, ['meta', 'updateSegMembershipPayload', 'isCreateNewSegment'], isCreateNewSegment);
      _.set(
        newModel.nodes[this.props.currentNode],
        `data[${this.props.subActionIndex}].meta.updateSegMembershipPayload.isCreateNewSegment`,
        isCreateNewSegment,
      );
      this.props.onModelChange(newModel);
    }
  };

  render() {
    const { model, currentNode, subActionIndex } = this.props;

    const subAction = _.get(
      model.nodes[currentNode],
      `data[${subActionIndex}]`,
    );
    const isNotDaxGroup = subAction.type !== 'updateDaxGroupMembership';
    const isAdd = !_.get(
      subAction,
      'meta.updateSegMembershipPayload.IsRemove',
      false,
    );
    const isCreateNewSegment = _.get(
      subAction,
      'meta.updateSegMembershipPayload.isCreateNewSegment',
      false,
    );
    const dropdownOptions = [
      {
        key: 'Remove',
        text: 'Remove',
        value: true,
      },
      {
        key: 'Add',
        text: 'Add',
        value: false,
      },
    ];
    const segmentFieldLabel = isNotDaxGroup
      ? i18n.t('targets_page.fields.segment_name')
      : i18n.t('targets_page.fields.segment_id');
    const targetUserType = (MEX_SEGMENT_SUB_ACTIONS.includes(subAction.type)) ? targetUserTypes.mex : model.targetUserType;
    const namespace = (subAction.type === 'updatePaxDigibankSegmentMembership') ? GXS_NAMESPACE : undefined;
    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <FormInputWithError
                name={`nodes.${currentNode}.data[${subActionIndex}].meta.updateSegMembershipPayload.SegmentName`}
                {...this.props}
              >
                <p>{segmentFieldLabel}</p>
                <SegPWidget
                  targetUserType={targetUserType}
                  namespace={namespace}
                  onChange={val =>
                    this.props.handleInputChange(
                      {},
                      {
                        name: `nodes.${currentNode}.data[${subActionIndex}].meta.updateSegMembershipPayload.SegmentName`,
                        value: val,
                      },
                    )
                  }
                  segmentVal={_.get(
                    model.nodes[currentNode],
                    `data[${subActionIndex}].meta.updateSegMembershipPayload.SegmentName`,
                  )}
                  maxVisible={30}
                  enabledSegmentNSFormat
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <FormInputWithError
                name={`nodes.${currentNode}.data[${subActionIndex}].meta.updateSegMembershipPayload.IsRemove`}
                {...this.props}
              >
                <CDropdown
                  required
                  label={i18n.t('targets_page.fields.add_remove')}
                  options={dropdownOptions}
                  value={_.get(
                    model.nodes[currentNode],
                    `data[${subActionIndex}].meta.updateSegMembershipPayload.IsRemove`,
                  )}
                  onChange={this.props.handleInputChange}
                  onBlur={this.props.handleControlBlur}
                />
              </FormInputWithError>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {isNotDaxGroup && isAdd && (
              <Grid.Column width={6}>
                <Checkbox
                  name="create_new_segment"
                  label={i18n.t('targets_page.fields.create_new_segment')}
                  onChange={this.handleToggleCreate}
                  checked={_.get(
                    model.nodes[currentNode],
                    `data[${subActionIndex}].meta.updateSegMembershipPayload.isCreateNewSegment`,
                  )}
                />
              </Grid.Column>
            )}
            {isNotDaxGroup && isAdd && isCreateNewSegment && (
              <Grid.Column width={6}>
                <FormInputWithError
                  name={`nodes.${currentNode}.data[${subActionIndex}].meta.updateSegMembershipPayload.segmentExpiryDate`}
                  {...this.props}
                >
                  <CDatePicker
                    required
                    showTimeSelect
                    label={i18n.t('targets_page.fields.segment_expiry_date')}
                    selected={_.get(
                      model.nodes[currentNode],
                      `data[${subActionIndex}].meta.updateSegMembershipPayload.segmentExpiryDate`,
                    )}
                    endDate={_.get(
                      model.nodes[currentNode],
                      `data[${subActionIndex}].meta.updateSegMembershipPayload.segmentExpiryDate`,
                    )}
                    handleInputChange={this.props.handleInputChange}
                    onBlur={this.props.handleControlBlur}
                  />
                </FormInputWithError>
              </Grid.Column>
            )}
          </Grid.Row>
          <Grid.Row>
            {isNotDaxGroup && (
              <Grid.Column width={24}>
                <p>   <Icon name="warning sign" color="yellow" /> As of March 4th, 2024, users cannot be added or removed from a pax segment created via
                  <a href={'https://cdp.grab.com/'} target={'_blank'} style={{ color: '#d64425' }}> Segp Portal </a>.
                  To proceed, please create a new segment through Trident by ticking <i>Create the segment if it does not exist</i></p>
              </Grid.Column>
            )}
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}
